/* Ilustraciones de línea para los grabados, al estilo de la hoja de referencia de Susana.
   No están en la tienda: se ven en ilustraciones.html.

   Van en una caja de 24×24 y las pinta dibujo() de cm-medalla-ia.js, que las traza con el grosor
   de línea real (0,18 mm). `class="f"` marca las partes macizas.

   Criterio: línea continua y fina, dibujo simplificado pero creíble, y mucho aire. Nada de iconos
   geométricos. Lo que no se sostenga a tamaño real no entra. */
(function (raiz) {
  'use strict';

  // --- brújula: la rosa de los vientos de «Aventura» -----------------------------------------
  // Cada punta, mitad maciza y mitad en línea (sombreado de media cara, guía de grabado).
  function punta(ang, largo, ancho, muesca) {
    // punta en forma de cometa desde el centro (12,12): vértice, dos muescas a los lados y el centro
    var a = ang * Math.PI / 180, ca = Math.sin(a), sa = -Math.cos(a);   // 0° = norte, sentido horario
    var px = function (d, l) { return [(12 + d * ca - l * sa).toFixed(2), (12 + d * sa + l * ca).toFixed(2)]; };
    var tip = px(largo, 0), izq = px(muesca, -ancho), der = px(muesca, ancho), c = ['12', '12'];
    return '<path d="M' + tip.join(' ') + ' ' + izq.join(' ') + ' ' + c.join(' ') + ' ' + der.join(' ') + 'Z"/>' +
      '<path d="M' + tip.join(' ') + ' ' + der.join(' ') + ' ' + c.join(' ') + 'Z" class="f"/>';
  }
  function brujula() {
    var s = '<circle cx="12" cy="12" r="10.4"/><circle cx="12" cy="12" r="8.9"/>';
    for (var i = 0; i < 32; i++) {                       // limbo: marcas cada 11,25°, más largas en los rumbos
      var a = i * Math.PI / 16, l = i % 8 === 0 ? 1.5 : i % 2 === 0 ? 0.95 : 0.5;
      s += '<path d="M' + (12 + 8.9 * Math.sin(a)).toFixed(2) + ' ' + (12 - 8.9 * Math.cos(a)).toFixed(2) +
        'L' + (12 + (8.9 + l) * Math.sin(a)).toFixed(2) + ' ' + (12 - (8.9 + l) * Math.cos(a)).toFixed(2) + '"/>';
    }
    [45, 135, 225, 315].forEach(function (g) { s += punta(g, 5.6, 0.8, 1.4); });   // rumbos intermedios, detrás
    [0, 90, 180, 270].forEach(function (g) { s += punta(g, 8.2, 1.35, 1.9); });    // los cuatro principales
    s += '<circle cx="12" cy="12" r="0.7" class="f"/>';
    return s;
  }

  // --- trébol de cuatro hojas: «Mensajes que inspiran» ----------------------------------------
  function trebol() {
    var hoja = 'M12 12C9.7 10.5 7.3 8.8 8.1 6.6 8.8 4.7 11 5.1 12 7.3 13 5.1 15.2 4.7 15.9 6.6 16.7 8.8 14.3 10.5 12 12Z';
    var s = '';
    for (var g = 0; g < 4; g++) s += '<path d="' + hoja + '" transform="rotate(' + (g * 90) + ' 12 12)"/>';
    return s + '<path d="M12 12C12.9 15.1 13.1 18.2 12.3 21"/>';
  }

  // --- montaña con la figura en la cumbre: «Superación» -------------------------------------
  // Silueta limpia de tres picos y, dentro, pocas líneas que siguen la ladera en sombra: es lo que da
  // volumen (principio 3 de la guía). La primera versión con aristas sueltas parecía un garabato.
  function montana() {
    return '<path d="M1.6 19.6 6.6 12.2 8.8 14.6 15.4 6.8 18.7 11.9 20.3 10.5 22.4 19.6"/>' +
      '<path d="M15.4 6.8 14.3 10.3 15.1 12.8M6.6 12.2 7.5 14.9M20.3 10.5 20.8 13.2"/>' +          // laderas en sombra
      '<path d="M14.2 8.6 14.9 9.2 15.4 8.6 15.9 9.3 16.6 8.6"/>' +                                 // borde de la nieve
      '<circle cx="15.4" cy="2.5" r="0.55"/>' +
      '<path d="M15.4 3.1 15.4 5.2M15.4 3.6 16.5 1.7M15.4 3.8 14.5 4.9M14.8 6.8 15.4 5.2 16 6.8"/>';
  }

  // --- cáliz con la hostia y su cruz: «Comuniones» ------------------------------------------
  // Como en la referencia de Susana: la hostia (un círculo con la cruz dentro) sobre la copa, y la
  // gloria en trazos cortos alrededor de la hostia, sin tocar la copa.
  function caliz() {
    var s = '<circle cx="12" cy="5.6" r="2.5"/>' +
      '<path d="M12 3.9 12 7.3M10.7 5 13.3 5"/>';
    [-100, -70, -45, -20, 20, 45, 70, 100].forEach(function (gr) {
      var a = gr * Math.PI / 180;
      s += '<path d="M' + (12 + 3.2 * Math.sin(a)).toFixed(2) + ' ' + (5.6 - 3.2 * Math.cos(a)).toFixed(2) +
        'L' + (12 + 4.3 * Math.sin(a)).toFixed(2) + ' ' + (5.6 - 4.3 * Math.cos(a)).toFixed(2) + '"/>';
    });
    s += '<path d="M7.2 10.4 16.8 10.4C16.8 14.9 14.8 17.2 12 17.2 9.2 17.2 7.2 14.9 7.2 10.4Z"/>';
    s += '<path d="M12 17.2 12 19.4"/>';
    s += '<path d="M8.4 21.5C8.4 20 9.9 19.4 12 19.4 14.1 19.4 15.6 20 15.6 21.5Z"/>';
    return s;
  }

  // --- paloma con la rama de olivo: «Bautizos» ----------------------------------------------
  // La primera versión tenía demasiadas líneas y no se resolvía en un pájaro. Menos trazos y más
  // limpios: cuerpo cerrado, un ala levantada, cola en abanico y el pico con la rama.
  function paloma() {
    var s =
      '<path d="M17.4 10.4C15.2 8.7 12.2 9.1 9.7 10.8 7.4 12.4 5.7 14.4 4.6 16.1' +
      'C7.1 16.8 10.7 16.2 13.5 14.3 15.7 12.8 16.9 11.6 17.4 10.4Z"/>' +
      '<path d="M17.4 10.4 19.9 9.7 18.3 11.5"/>' +
      '<circle cx="16.1" cy="10.8" r="0.32" class="f"/>' +
      '<path d="M11.3 11.6C11.2 8.2 12.7 5.2 15.4 3.7 15 6.8 14.3 9.6 13.2 12.4"/>' +
      '<path d="M12.4 10.6C12.7 8.4 13.4 6.6 14.4 5.4"/>' +
      '<path d="M4.6 16.1 1.5 15.1M4.8 16.6 1.7 17.6M5.5 17.1 3.3 19.5"/>';
    s += '<path d="M19.9 9.7C21.3 11.5 21.9 13.7 21.4 15.9"/>';
    [[20.9, 11.6, 1], [21.6, 13.4, -1], [21.4, 15.1, 1]].forEach(function (h) {
      var d = h[2];
      s += '<path d="M' + h[0] + ' ' + h[1] +
        'C' + (h[0] + 1.3 * d) + ' ' + (h[1] - 0.9) + ' ' + (h[0] + 2.0 * d) + ' ' + (h[1] + 0.1) +
        ' ' + (h[0] + 1.6 * d) + ' ' + (h[1] + 1.0) +
        'C' + (h[0] + 0.9 * d) + ' ' + (h[1] + 1.0) + ' ' + (h[0] + 0.3 * d) + ' ' + (h[1] + 0.7) +
        ' ' + h[0] + ' ' + h[1] + 'Z" class="f"/>';
    });
    return s;
  }
  // --- calendario del mes, con el dia senalado: «Fechas especiales» ---------------------------
  // No va en caja de 24x24: se dibuja en milimetros porque tiene que ajustarse a la joya.
  // Devuelve null si no cabe con la letra minima de taller: en la medalla de 15 mm NO cabe.
  var DIAS = ['L', 'M', 'X', 'J', 'V', 'S', 'D'];
  var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
               'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

  function calendario(anio, mes, dia, radioGrabable, ink, opciones) {
    opciones = opciones || {};
    // opciones: tam, titulo, minimo (letra minima de taller, 1,6 por defecto), sinTitulo, letraDatos
    var minLetra = opciones.minimo || 1.6, f2 = function (v) { return (+v || 0).toFixed(3); };
    var tamDia = opciones.tam || minLetra;
    var paso = tamDia * 1.42;                       // separacion entre columnas y filas
    var ancho = paso * 7, filas = 6;
    var altoRejilla = paso * (filas + 1);           // +1 por la fila de iniciales
    var cabecera = opciones.sinTitulo ? 0 : tamDia * 3.6;   // dos lineas de titulo, o ninguna
    var alto = cabecera + altoRejilla;
    // la rejilla es un rectangulo: tiene que caber en el circulo grabable
    var media = Math.sqrt(ancho * ancho + alto * alto) / 2;
    if (tamDia < minLetra || media > radioGrabable) {
      return { cabe: false, necesita: +(2 * media).toFixed(1) };
    }
    var x0 = -ancho / 2 + paso / 2, y0 = -alto / 2;
    var primero = new Date(Date.UTC(anio, mes - 1, 1));
    var col0 = (primero.getUTCDay() + 6) % 7;        // lunes = 0
    var ultimo = new Date(Date.UTC(anio, mes, 0)).getUTCDate();
    var s = '';
    var T = function (t, x, y, tam, letra, extra) {
      return '<text x="' + f2(x) + '" y="' + f2(y) + '" text-anchor="middle" dominant-baseline="central"' +
        ' font-family="\'' + letra + '\'" font-size="' + f2(tam) + '" fill="' + ink + '"' + (extra || '') + '>' + t + '</text>';
    };
    if (!opciones.sinTitulo) {
      s += T(opciones.titulo || 'Nuestra historia', 0, y0 + tamDia * 0.9, tamDia * 1.5, 'Cormorant Garamond', ' font-style="italic"');
      s += T(MESES[mes - 1].charAt(0).toUpperCase() + MESES[mes - 1].slice(1) + ' ' + anio,
             0, y0 + tamDia * 2.7, tamDia * 1.15, 'Cormorant Garamond');
    }
    // sin titulo, la rejilla se centra: si no, la fila de dias quedaria media letra por encima de la caja
    var yRej = y0 + cabecera + (opciones.sinTitulo ? paso / 2 : 0);
    DIAS.forEach(function (d, i) { s += T(d, x0 + i * paso, yRej, tamDia * 0.95, opciones.letraDatos || 'Cinzel'); });
    for (var n = 1; n <= ultimo; n++) {
      var k = col0 + n - 1, cx = x0 + (k % 7) * paso, cy = yRej + paso * (1 + Math.floor(k / 7));
      if (n === dia) {
        // el dia senalado es un corazon macizo, no el numero
        var t = 0.62 * tamDia;
        s += '<path d="M0 .95C0 .95-1 .35-1-.3-1-.72-.66-1-.3-1-.14-1 0-.9 0-.72 0-.9.14-1 .3-1 .66-1 1-.72 1-.3 1 .35 0 .95 0 .95Z" transform="translate(' +
          f2(cx) + ' ' + f2(cy - t * 0.1) + ') scale(' + f2(t) + ')" fill="' + ink + '"/>';
      } else {
        s += T(String(n), cx, cy, tamDia, opciones.letraDatos || 'Cormorant Garamond');
      }
    }
    return { cabe: true, markup: s, ancho: ancho, alto: alto, diametro: +(2 * media).toFixed(1) };
  }

  raiz.cmIlustraciones = {
    ILUS: { brujula: brujula(), trebol: trebol(), montana: montana(), caliz: caliz(), paloma: paloma() },
    calendario: calendario
  };
})(typeof window !== 'undefined' ? window : globalThis);
